
import { useState, useEffect } from 'react';
import { Session } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export const useAuthSession = () => {
  // Utiliser sessionStorage pour une persistance entre rechargements de page
  const getStoredSession = () => {
    const storedSession = sessionStorage.getItem('supabase_session');
    try {
      return storedSession ? JSON.parse(storedSession) : null;
    } catch (e) {
      console.error('Erreur lors de la récupération de la session stockée:', e);
      return null;
    }
  };

  const [session, setSession] = useState<Session | null>(getStoredSession);

  // Gestionnaire optimisé pour mettre à jour la session
  const handleSessionUpdate = (newSession: Session | null) => {
    setSession(newSession);
    
    if (newSession) {
      // Stocker dans sessionStorage pour une persistance optimisée
      try {
        sessionStorage.setItem('supabase_session', JSON.stringify(newSession));
      } catch (e) {
        console.error('Erreur lors du stockage de la session:', e);
      }
    } else {
      // Nettoyer si déconnexion
      sessionStorage.removeItem('supabase_session');
      sessionStorage.removeItem('admin_role');
      sessionStorage.removeItem('admin_name');
      sessionStorage.removeItem('admin_cache_timestamp');
    }
  };

  // Synchroniser la session avec Supabase au chargement
  useEffect(() => {
    // Récupérer la session actuelle au montage
    const getInitialSession = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        handleSessionUpdate(data.session);
      } catch (error) {
        console.error('Erreur lors de la récupération de la session initiale:', error);
      }
    };

    getInitialSession();

    // Écouter les changements de session
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, newSession) => {
        handleSessionUpdate(newSession);
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { session, setSession: handleSessionUpdate };
};
